import { Paper, PaperProps, Typography } from '@mui/material'
import React from 'react'
import LockIcon from '@mui/icons-material/Lock'

type Props = PaperProps & {
  title: string
  lock?: boolean
  children: React.ReactNode
}

const SectionCard: React.FC<Props> = ({ title, lock, children, sx, ...props }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: '20px',
        p: 3,
        width: '100%',
        overflow: 'visible',
        height: '259px',
        ...sx, // allows override o agregar styles
      }}
      {...props}>
      {lock && (
        <LockIcon fontSize="medium" sx={{ position: 'absolute', top: '16px', right: '16px', color: 'rgb(16, 163, 127)' }} />
      )}

      <Typography pb={2} variant="h5">
        {title}
      </Typography>
      {children}
    </Paper>
  )
}

export default SectionCard
